import React from 'react';
import { IFilterItem } from '../interfaces';
import Divider from './divider';
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';
import { useAppSelector } from '../data/store';

interface ISearchItemProps {
    filterItem: IFilterItem;
    position: number;
    isLast: boolean;
}

const SearchItem = (props : ISearchItemProps) => {

    const { filterItem, position, isLast } = props;

    const query = useAppSelector(store => store.root.query);

    const sendClickGAEvent = () => {
        // q: {query} | pos: {position} | page: {distinationURL}
        // q: api | pos: 3 | page: /plugins/api-2500
        sendGAEvent('SQLSearchClick', `q: ${ query.toLowerCase() } | pos: ${ position  + 1 } | page: ${ filterItem.documentUrlPath }`);
    };

    return (
        <div className="w-full">

            <div className="flex items-center justify-center ">
                <div className="flex-1">
                    <div className="font-bold text-base md:text-lg p-1 pt-4 md:pt-5">
                        <a
                            className="no-underline text-black"
                            href={filterItem.documentUrlPath}
                            onClick={sendClickGAEvent}
                            rel="noreferrer">
                            {filterItem.documentName}
                        </a>
                    </div>

                    <div
                        className={`w-full p-1 pt-3 md:pt-4 w-ellipsis w-line-clamp-2`}
                        dangerouslySetInnerHTML={{__html: filterItem.documentPageDescription}}
                    />

                    {/*<div className="w-full p-1 pt-3 md:pt-4">
                        <a className="text-gray-700 no-underline" href={filterItem.documentUrlPath} rel="noreferrer">
                            {"Read More >"}
                        </a>
                    </div>*/}

                    <div className="hidden md:block w-full p-1">
                        <a
                            href={filterItem.documentUrlPath}
                            onClick={sendClickGAEvent}
                            rel="noreferrer">
                            https://{window.location.host}{filterItem.documentUrlPath}
                        </a>
                    </div>
                </div>
            </div>

            {!isLast && <Divider/>}

        </div>


    )
};

export default SearchItem;